import { quantityUnitSuffix } from "@/lib/mrpSkuUnitDisplay";
import { TapDisabledReason } from "@/components/ui/TapDisabledReason";
import { cn } from "@/lib/utils";
import { formatNumber } from "./inboundApi";
import type { InboundLineRow } from "./inboundApi";

export {
  canonicalInboundLineForSku,
  collapseInboundLinesBySku,
  inboundLineIdsForSku,
  inboundLinesShareSku,
  resolveInboundReceiveLineId,
  sortInboundLinesStable,
} from "./inboundReceiveLineSort";

export function InboundReceiveLineTile({
  line,
  selected,
  disabled,
  disabledReason = null,
  openQuantity,
  closedQuantity,
  onSelect,
}: {
  line: InboundLineRow;
  selected: boolean;
  disabled: boolean;
  disabledReason?: string | null;
  openQuantity: number;
  closedQuantity: number;
  onSelect: () => void;
}): JSX.Element {
  return (
    <TapDisabledReason reason={disabledReason} fill>
    <button
      type="button"
      disabled={disabled}
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        "box-border flex h-full min-h-[6.75rem] w-full flex-col rounded-lg border-2 p-2 text-left transition",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-1",
        selected
          ? "border-brand-500 bg-brand-50 shadow-sm"
          : "border-slate-300 bg-white hover:border-slate-400 active:bg-slate-50",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
      )}
    >
      <p className="line-clamp-2 font-mono text-sm font-semibold leading-snug text-slate-900">{line.sku}</p>
      <p className="mt-1 line-clamp-2 text-[11px] leading-snug text-slate-700">
        {line.description ?? "-"}
      </p>
      <div className="mt-auto grid shrink-0 grid-cols-2 gap-0.5 border-t border-slate-200 pt-1 text-center text-[10px]">
        <div>
          <p className="text-slate-500">Open</p>
          <p className="font-semibold tabular-nums text-brand-800">
            {formatNumber(openQuantity)} {quantityUnitSuffix(line.unit_of_measure)}
          </p>
        </div>
        <div>
          <p className="text-slate-500">Labeled</p>
          <p className="font-semibold tabular-nums text-slate-900">
            {formatNumber(closedQuantity)} {quantityUnitSuffix(line.unit_of_measure)}
          </p>
        </div>
      </div>
    </button>
    </TapDisabledReason>
  );
}
